import { RootState } from "src/store/store";

/**
 * 
 */
export namespace PolicyVehicleDataSelector {

  export const storedVehicle = (state: RootState) => state.vehicleData?.storedVehicle;
}
